/* eslint-disable no-console */
import { formatDate, getAuthorUrl, setLocaleStatusCell, updatePaginationControls } from './utils.js'

export function renderTableInternal({ currentData, currentPage, pageSize, totalCount }) {
  const tableBody = document.getElementById('tableBody')
  if (!tableBody) {
    return
  }

  tableBody.innerHTML = ''
  const exportBtn = document.getElementById('exportCsvBtn')
  if (exportBtn) {
    if (currentData.length === 0) {
      exportBtn.disabled = true
    } else {
      exportBtn.disabled = false
    }
  }

  currentData.forEach(item => {
    const { title, lastModified, lastActivated, path, status, translationStatus = {}, outdatedLocales = [] } = item
    console.log('Rendering row for item:', item) // Debug log to check data structure

    const row = document.createElement('tr')
    // Page title
    const titleCell = document.createElement('td')
    const titleLink = document.createElement('a')
    titleLink.href = getAuthorUrl(path)
    titleLink.target = '_blank'
    titleLink.textContent = title
    titleCell.appendChild(titleLink)
    row.appendChild(titleCell)
    // Last modified / activated (formatted as MM/DD/YY)
    const modifiedCell = document.createElement('td')
    const formattedLastModified = lastModified && lastModified !== 'NA' ? formatDate(lastModified) : 'NA'
    modifiedCell.textContent = formattedLastModified
    row.appendChild(modifiedCell)
    const activatedCell = document.createElement('td')
    const formattedLastActivated = lastActivated && lastActivated !== 'NA' ? formatDate(lastActivated) : 'NA'
    activatedCell.textContent = formattedLastActivated
    row.appendChild(activatedCell)
    const statusCell = document.createElement('td')
    statusCell.textContent = status || 'Unpublished'
    row.appendChild(statusCell)
    // Locales status
    window.locales.forEach(locale => {
      const { status, localeModified, isRedirect: localeIsRedirect, redirectTarget } = translationStatus[locale] || {}
      const cell = document.createElement('td')

      // Use locale-specific redirect status
      const shouldShowRedirect = localeIsRedirect || 'false'

      // Use lastModified as the best available proxy for "Last Synced Date" in the tooltip
      setLocaleStatusCell({ cell, status, lastSyncedDate: localeModified, isRedirect: shouldShowRedirect, redirectTarget })
      row.appendChild(cell)
    })

    // Outdated locales
    const outdatedCell = document.createElement('td')
    if (outdatedLocales && outdatedLocales.length > 0) {
      outdatedCell.textContent = outdatedLocales.join(', ')
      outdatedCell.style.color = 'orange'
    } else {
      outdatedCell.textContent = 'NA'
      outdatedCell.style.color = 'gray'
    }
    row.appendChild(outdatedCell)

    tableBody.appendChild(row)
  })

  updatePaginationControls(totalCount, currentPage, pageSize)
}
